// tslint:disable
export enum PhoneContactInformationType {
    /**
     * @description PHONE
     */
    PHONE = 1,
    /**
     * @description MOBILE
     */
    MOBILE = 2,
    /**
     * @description FAX
     */
    FAX = 3,
}
